import {HTTP_METHODS} from '../httpMethods';
import {Constants, FILE_UPLOAD_TEMPLATE_TYPE} from '../commonConstants';
import {buildQueryParams} from '@/utils/commons';

const getType = (templateType) => {
  switch (templateType) {
    case Constants.BulkRewards:
      return FILE_UPLOAD_TEMPLATE_TYPE.REWARD_CATALOG;
    case Constants.BulkDigitalCodes:
      return FILE_UPLOAD_TEMPLATE_TYPE.DIGITAL_CODES;
    case Constants.Leaderboard:
      return FILE_UPLOAD_TEMPLATE_TYPE.LEADERBOARD;
    case Constants.ActivityMedia:
      return FILE_UPLOAD_TEMPLATE_TYPE.ACTIVITY;
    case Constants.BulkModifiers:
      return FILE_UPLOAD_TEMPLATE_TYPE.BULK_POINT_MODIFIER;
    case Constants.PerfectStore:
      return FILE_UPLOAD_TEMPLATE_TYPE.PERFECT_STORE;
    default:
      return FILE_UPLOAD_TEMPLATE_TYPE.SALES_TARGET;
  }
};

export const SAS_TOKEN_CONFIG = {
  GET_SAS_TOKEN: (fileName, templateType, extraParams) => {
    const params = {
      fileName,
      templateType: getType(templateType),
      ...extraParams
    };
    return {
      endPoint: `template/upload-url?${buildQueryParams(params)}`,
      method: HTTP_METHODS.GET
    };
  }
};
